import Box from "@mui/material/Box";
import { useState } from "react";
import images from "../../global-styles/images";
import { appLogger } from "../../utils";
import BasicDetails from "./BasicDetails";

import AddIcon from "@mui/icons-material/Add";
import {
  Button,
  Dialog,
  Divider,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  OutlinedInput,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { IProductParams } from "../../model";
import AuthModal from "./AuthModal";
import Platform from "./PlartformCard";
import { withSnackbar } from "../../utils/common/SnackbarHoc";
import CloseIcon from "@mui/icons-material/Close";
import SchoolIcon from "@mui/icons-material/School";
import EmailIcon from "@mui/icons-material/Email";
import {
  enableChatbot,
  enableFeedback,
  enablePlaystore,
  enableZendesk,
  enableJira,
  enableMailReply,
  enableBugReport,
  enableFeatureRequest,
} from "../../utils/config";

import "./styles.css";

function AccountsForm(props: any) {
  appLogger.info({
    infoObj: {
      method: "AccountsForm",
      component: "add-account",
      fileName: "AccountsForm.tsx",
      props: props,
    },
  });
  const {
    productParams,
    setProductParams,
    errMsg,
    setErrMsg,
    setScroll,
    sethandleClick,
    basicSettingsMandatoryCheck,
  } = props;
  let userEnabledFeatures: any = localStorage.getItem("userenabledFeatures");
  // console.log(JSON.parse(userEnabledFeatures), "userEnabledFeatures");
  if (userEnabledFeatures) {
    userEnabledFeatures = JSON.parse(userEnabledFeatures);
  }
  const platforms = [
    {
      category: "Agent",
      options: [
        {
          id: "kb",
          name: "knowledge Base",
          logo: <SchoolIcon />,
          appLevelEnableFeature: enableChatbot,
          orgLevelEnableFeature: userEnabledFeatures?.enableChatbot,
        },
        {
          id: "chat",
          name: "Chat",
          logo: images.chatbotlogo,
          appLevelEnableFeature: enableChatbot,
          orgLevelEnableFeature: userEnabledFeatures?.enableChatbot,
        },
        {
          id: "agent",
          name: "Feedback",
          logo: images.cuvoLogo,
          appLevelEnableFeature:
            enableFeedback || enableBugReport || enableFeatureRequest,
          orgLevelEnableFeature:
            userEnabledFeatures?.enableFeedback ||
            userEnabledFeatures?.enableBugReport ||
            userEnabledFeatures?.enableFeatureRequest,
        },
      ],
    },
    {
      category: "Integration",
      options: [
        {
          id: "jira",
          name: "Jira",
          logo: images.jiraLogo,
          appLevelEnableFeature: enableJira,
          orgLevelEnableFeature: userEnabledFeatures?.enableJira,
        },
        {
          id: "zendesk",
          name: "Zendesk",
          logo: images.zenDeskLogo,
          appLevelEnableFeature: enableZendesk,
          orgLevelEnableFeature: userEnabledFeatures?.enableZendesk,
        },
        {
          id: "email",
          name: "Email",
          logo: <EmailIcon />,
          appLevelEnableFeature: enableMailReply,
          orgLevelEnableFeature: userEnabledFeatures?.enableMailReply,
        },
        {
          id: "googlereview",
          name: "Google Store Review",
          logo: images.googleLogo,
          appLevelEnableFeature: enablePlaystore,
          orgLevelEnableFeature: userEnabledFeatures?.enablePlaystore,
        },
      ],
    },
  ];

  const [authModal, setAuthModal] = useState(false);
  const [selectedPlatform, setSelectedPlatform] = useState("");
  const [addUrlModal, setAddUrlModal] = useState(false);
  const [kbUrl, setKbUrl] = useState("");
  const [kbDoc, setKbDoc] = useState("");
  const [chatSettingModal, setChatSettingModal] = useState(false);
  const [trainingInProgress, setTrainingInProgress] = useState(false);

  const navigate = useNavigate();

  const handleClose = () => {
    setAddUrlModal(false);
  };

  const handleKBUrl = (e: any) => {
    if (productParams) {
      const temp: IProductParams | undefined = { ...productParams };
      if (temp && temp.products && temp.products[0]) {
        temp.products[0].knowledgeBaseUrl = {
          url: e.target.value,
        };
        setProductParams(temp);
      }
    }
    setKbUrl(e.target.value);
  };

  const handleKBDoc = (e: any) => {
    setKbDoc(e.target.value);
  };

  const handleUpload = () => {
    props.snackbarShowMessage(
      "Your chatbot is being trained using the knowledgebase url. It will take few hours. You can view the status on this page",
      "info",
      3000
    );
    setAddUrlModal(false);
    setTrainingInProgress(true);
  };

  const handleRetrain = () => {
    props.snackbarShowMessage(
      "Your chatbot is being trained using the knowledgebase url. It will take few hours. You can view the status on this page",
      "info",
      3000
    );
    setAddUrlModal(false);
    setTrainingInProgress(true);
  };

  const handleOpenAuthModal = (id: string) => {
    setSelectedPlatform(id);
    if (id === "kb") {
      const product = productParams?.products?.[0];
      navigate(`/knowledgebase-settings/${product.id}/${product.version}`, {
        state: {
          product: product,
        },
      });
    } else if (id == "agent") {
      const product = productParams?.products?.[0];

      navigate(`/agent-settings/${product.id}/${product.version}`, {
        state: {
          product: product,
        },
      });
    } else if (id == "email") {
      const product = productParams?.products?.[0];

      navigate(`/email-settings/${product.id}/${product.version}`, {
        state: {
          product: product,
        },
      });
    } else if (id == "zendesk") {
      const product = productParams?.products?.[0];

      navigate(`/zendesk-settings/${product.id}/${product.version}`, {
        state: {
          product: product,
        },
      });
    } else if (id == "jira") {
      const product = productParams?.products?.[0];

      navigate(`/jira-settings/${product.id}/${product.version}`, {
        state: {
          product: product,
        },
      });
    } else if (id == "chat") {
      const product = productParams?.products?.[0];
      navigate(`/chat-settings/${product.id}/${product.version}`, {
        state: {
          product: product,
        },
      });
      // setChatSettingModal(true);
      // setAddUrlModal(false);
      // setAuthModal(false);
    } else {
      setChatSettingModal(false);
      setAddUrlModal(false);
      setAuthModal(true);
    }
  };

  const handleCloseAuthModal = () => {
    setSelectedPlatform("");
    setAuthModal(false);
    setAddUrlModal(false);
  };

  const renderCategoryCheck = (cat: any) => {
    const results = cat.options.filter((element: any) => {
      return element.appLevelEnableFeature && element.orgLevelEnableFeature;
    });
    return results.length > 0 ? cat.category : "";
  };
  return (
    <Box sx={{ padding: "20px 45px 70px 45px" }}>
      <Grid item xs={24}>
        <BasicDetails
          productParams={productParams}
          setScroll={setScroll}
          setProductParams={setProductParams}
          errMsg={errMsg}
          setErrMsg={setErrMsg}
          sethandleClick={sethandleClick}
          basicSettingsMandatoryCheck={basicSettingsMandatoryCheck}
        />
      </Grid>
      {productParams &&
        productParams.products &&
        productParams.products[0] &&
        productParams.products[0].id && (
          <Grid
            container
            xs={12}
            columnGap="13px"
            rowGap="13px"
            mt={4}
            justifyContent="center"
            className="onboard-features-grid"
          >
            {platforms.map((d: any) => {
              return (
                <>
                  <Grid
                    container
                    xs={12}
                    mt={1}
                    justifyContent="center"
                    className="onboard-features-grid-cat-par"
                  >
                    <p className="onboard-features-grid-cat">
                      {renderCategoryCheck(d)}
                    </p>
                  </Grid>
                  {d.options.map((platform: any) => {
                    return (
                      platform.appLevelEnableFeature &&
                      platform.orgLevelEnableFeature && (
                        <>
                          <Platform
                            platform={platform}
                            handleOpenAuthModal={handleOpenAuthModal}
                            trainingInProgress={trainingInProgress}
                            productParams={productParams}
                            isDisable={
                              productParams?.products[0]?.cloneNewVersion ||
                              false
                            }
                          />
                        </>
                      )
                    );
                  })}
                </>
              );
            })}
          </Grid>
        )}

      {/* disable cards for the clone product, Clone product doesn't have id but chatAgentSettings */}
      {productParams &&
        productParams.products &&
        productParams.products[0] &&
        !productParams.products[0].id &&
        productParams.products[0].cloneNewProduct && (
          <Grid
            container
            xs={12}
            columnGap="13px"
            rowGap="13px"
            mt={4}
            justifyContent="center"
            className="onboard-features-grid"
          >
            {platforms.map((d: any) => {
              return (
                <>
                  <Grid
                    container
                    xs={12}
                    mt={1}
                    justifyContent="center"
                    className="onboard-features-grid-cat-par"
                  >
                    <p className="onboard-features-grid-cat">
                      {renderCategoryCheck(d)}
                    </p>
                  </Grid>
                  {d.options.map((platform: any) => {
                    return (
                      platform.appLevelEnableFeature &&
                      platform.orgLevelEnableFeature && (
                        <>
                          <Platform
                            platform={platform}
                            handleOpenAuthModal={handleOpenAuthModal}
                            trainingInProgress={trainingInProgress}
                            productParams={productParams}
                            isDisable={
                              (productParams &&
                                productParams.products &&
                                productParams.products[0] &&
                                !productParams.products[0].id &&
                                productParams.products[0].cloneNewProduct) ||
                              false
                            }
                          />
                        </>
                      )
                    );
                  })}
                </>
              );
            })}
          </Grid>
        )}

      {authModal && (
        <AuthModal
          open={authModal}
          onClose={handleCloseAuthModal}
          platform={selectedPlatform}
          productParams={productParams}
          setProductParams={setProductParams}
        />
      )}

      {chatSettingModal &&
        productParams &&
        setProductParams &&
        navigate("/add-chatbots", { state: { productParams } })}

      {addUrlModal && (
        <Dialog open={addUrlModal} onClose={handleClose}>
          <Grid container p={3} sx={{ width: "600px" }}>
            <Grid item xs={12} md={6}>
              <Typography>ADD KB URL</Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                }}
              >
                <CloseIcon />
              </IconButton>
            </Grid>

            <Grid item xs={12} mt={2}>
              <FormControl className="custom-select" fullWidth>
                <InputLabel>Please provide url for knowledge base</InputLabel>
                <OutlinedInput
                  type="text"
                  value={
                    productParams?.products[0]?.knowledgeBaseUrl?.url
                      ? productParams?.products[0]?.knowledgeBaseUrl?.url
                      : ""
                  }
                  onChange={handleKBUrl}
                  id="kburl-select"
                  label="kbUrl"
                />
              </FormControl>
            </Grid>

            <Grid container spacing={2} mt={1}>
              <Grid item xs={12} md={1.5}>
                <Button
                  type="button"
                  variant="outlined"
                  sx={{
                    textTransform: "uppercase",
                    borderRadius: "24px",
                  }}
                  onClick={handleUpload}
                >
                  Add
                </Button>
              </Grid>
              <Grid item xs={12} md={3}>
                <Button
                  type="button"
                  variant="outlined"
                  sx={{
                    textTransform: "uppercase",
                    borderRadius: "24px",
                  }}
                  onClick={handleRetrain}
                >
                  Retrain
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Dialog>
      )}
    </Box>
  );
}

export default withSnackbar(AccountsForm);
